// extracted by mini-css-extract-plugin
module.exports = {"actions":"auth-buttons-module--actions--3Hiu9","buttons":"auth-buttons-module--buttons--1V6fx"};